var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.236,
    height: 87.477,
    viewBox: "0 0 129.236 87.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 129.236,
    height: 87.477,
    fill: "#72cddc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cash",
    transform: "translate(-1302.075 -999.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(1302.075 999.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M82.75,3.419C80.922,4.738,79,5.971,77.035,7.156L90.643,38.32a101.767,101.767,0,0,1-19.965,11.2,164.512,164.512,0,0,1-21.929,7.761A206.485,206.485,0,0,0,20.2,67.559c-2.075.905-3.91,1.738-5.509,2.479l3.263,7.475s4.633-2.364,11.581-5.4A206.578,206.578,0,0,1,58.084,61.842a164.479,164.479,0,0,0,21.931-7.761,101.823,101.823,0,0,0,19.965-11.2Z",
    transform: "translate(14.103 3.281)",
    fill: "#72cddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M82.019,0A112.009,112.009,0,0,1,61.662,11.249,168.642,168.642,0,0,1,40.13,18.963,206.392,206.392,0,0,0,11.583,29.237C4.635,32.271,0,34.634,0,34.634L17.223,74.094s4.635-2.364,11.583-5.4A206.23,206.23,0,0,1,57.353,58.423a164.479,164.479,0,0,0,21.931-7.761,101.808,101.808,0,0,0,19.963-11.2ZM9.576,45.774,5.615,36.7c1.954-.929,4.6-2.152,7.7-3.506h0c.639-.28,1.317-.57,2.009-.866A16.225,16.225,0,0,1,9.576,45.774m17.5,18.963c-3.083,1.344-5.709,2.558-7.7,3.5L15.348,59a16.307,16.307,0,0,1,13.2,5.1c-.5.216-1,.429-1.47.637m7.185-16.958a4.4,4.4,0,1,1-.31-6.209,4.4,4.4,0,0,1,.31,6.209M55.877,50.3c-4.974,2.173-11.349-1.431-14.24-8.051s-1.2-13.744,3.775-15.918,11.351,1.433,14.24,8.053,1.2,13.744-3.775,15.916M72.82,32.676a4.4,4.4,0,1,1-.308-6.209,4.4,4.4,0,0,1,.308,6.209M70.8,11.724c3.359-1.7,6.479-3.447,9.331-5.246l4.455,10.2A16.243,16.243,0,0,1,70.8,11.724M90.078,29.255l3.8,8.713a91.259,91.259,0,0,1-9.272,5.4,16.422,16.422,0,0,1,5.468-14.115",
    transform: "translate(0 -0.001)",
    fill: "#72cddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M90.483,6.83c-1.829,1.319-3.753,2.552-5.715,3.737L98.376,41.731a101.767,101.767,0,0,1-19.965,11.2A164.51,164.51,0,0,1,56.482,60.7,206.487,206.487,0,0,0,27.935,70.97c-2.075.905-3.91,1.738-5.509,2.479l3.263,7.475s4.633-2.364,11.581-5.4A206.577,206.577,0,0,1,65.817,65.253a164.48,164.48,0,0,0,21.931-7.761,101.823,101.823,0,0,0,19.965-11.2Z",
    transform: "translate(21.525 6.555)",
    fill: "#72cddc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.f9496839b10cf7e412ff1b4ad731da7c.svg";
export { ForwardRef as ReactComponent };